<template>
  <v-container fluid>
    <!-- Sidebar -->
    <SidebarNavigation />

    <v-form v-model="formValid" @submit.prevent="submit">
      <v-text-field
        v-model="oldPassword"
        label="Password Lama"
        required
        :type="showPasswordOld ? 'text' : 'password'"
        :append-icon="showPasswordOld ? 'mdi-eye' : 'mdi-eye-off'"
        @click:append="togglePasswordVisibilityOld"
      ></v-text-field>

      <v-text-field
        v-model="newPassword"
        :rules="newPasswordRules"
        label="Password Baru"
        :type="showPasswordNew ? 'text' : 'password'"
        required
        :append-icon="showPasswordNew ? 'mdi-eye' : 'mdi-eye-off'"
        @click:append="togglePasswordVisibilityNew"
      ></v-text-field>

      <v-text-field
        v-model="confirmPassword"
        :rules="confirmPasswordRules"
        label="Konfirmasi Password Baru"
        :type="showPasswordConfirm ? 'text' : 'password'"
        required
        :append-icon="showPasswordConfirm ? 'mdi-eye' : 'mdi-eye-off'"
        @click:append="togglePasswordVisibilityConfirm"
      ></v-text-field>

      <v-btn :disabled="!formValid" color="primary" type="submit"
        >Ubah Password</v-btn
      >
    </v-form>

    <!-- Snackbar Notifications -->
    <snackbarMessage />
  </v-container>
</template>

<script>
import api from "@/utils/api";
import SidebarNavigation from "@/components/SidebarNavigation.vue";
import snackbarMessage from "@/components/snackbarMessage.vue";
import store from "@/store";

export default {
  components: {
    SidebarNavigation,
    snackbarMessage,
  },
  data() {
    return {
      showPasswordOld: false,
      showPasswordNew: false,
      showPasswordConfirm: false,
      formValid: false,
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
      oldPasswordRules: [
        (v) => !!v || "Password Lama required",
        (v) => v.length >= 8 || "Password must be at least 8 characters",
        (v) =>
          /[A-Z]/.test(v) ||
          "Password must contain at least one uppercase letter",
        (v) =>
          /[a-z]/.test(v) ||
          "Password must contain at least one lowercase letter",
        (v) => /[0-9]/.test(v) || "Password must contain at least one number",
        (v) =>
          /[!@#$%^&*(),.?":{}|<>]/.test(v) ||
          "Password must contain at least one special character",
      ],
      newPasswordRules: [
        (v) => !!v || "Password Baru required",
        (v) => v.length >= 8 || "Password must be at least 8 characters",
        (v) =>
          /[A-Z]/.test(v) ||
          "Password must contain at least one uppercase letter",
        (v) =>
          /[a-z]/.test(v) ||
          "Password must contain at least one lowercase letter",
        (v) => /[0-9]/.test(v) || "Password must contain at least one number",
        (v) =>
          /[!@#$%^&*(),.?":{}|<>]/.test(v) ||
          "Password must contain at least one special character",
      ],
      confirmPasswordRules: [
        (v) => !!v || "Konfirmasi password diperlukan",
        (v) =>
          v === this.newPassword || "Password baru dan konfirmasi tidak cocok",
      ],
    };
  },
  methods: {
    async submit() {
      const payload = {
        oldPassword: this.oldPassword,
        newPassword: this.newPassword,
      };

      api
        .post("/employees/change-password", payload)
        .then((response) => {
          // Mengambil pesan dari backend
          const message = response.data.message; // Pesan dari backend

          // Memanggil action Vuex untuk menampilkan snackbar dengan status success (hijau)
          store.dispatch("triggerSnackbar", { message, isSuccess: true });
        })
        .catch((error) => {
          let message = "Failed to Change password!"; // Pesan default jika error

          if (error.response) {
            // Jika ada respons error dari backend
            message = error.response.data.message || message; // Pesan error dari backend (jika ada)
          } else {
            message = error.message || message; // Pesan error default
          }

          // Menampilkan snackbar dengan status error (merah)
          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: false,
          });
        });
    },
    togglePasswordVisibilityOld() {
      console.log("test");
      this.showPasswordOld = !this.showPasswordOld; // Toggle password visibility
    },
    togglePasswordVisibilityNew() {
      this.showPasswordNew = !this.showPasswordNew; // Toggle password visibility
    },
    togglePasswordVisibilityConfirm() {
      this.showPasswordConfirm = !this.showPasswordConfirm; // Toggle password visibility
    },
  },
};
</script>

<style scoped>
.v-btn {
  margin-top: 20px;
}
</style>
